import HttpService from "./HttpService";
const API_ENDPOINT = "theme";

const ThemeService = {
  async fetchThemeById(id) {
    try {
      const response = await HttpService.get(`/${API_ENDPOINT}/color-get/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async fetchTheme() {
    try {
      const response = await HttpService.get(`/${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async changeTheme(data) {
    try {
      const response = await HttpService.post(`/${API_ENDPOINT}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async resetTheme(id) {
    try {
      const response = await HttpService.delete(`/${API_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchSidebarTheme() {
    try {
      const response = await HttpService.get(`/sidebar-${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async changeSidebarTheme(data) {
    try {
      const response = await HttpService.post(`/sidebar-${API_ENDPOINT}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async resetSidebarTheme(id) {
    try {
      const response = await HttpService.delete(
        `/sidebar-${API_ENDPOINT}/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ThemeService;
